/* =============================================================
   EC CART DRAWER ENGINE  ·  Everyday Chemist (V2)
   Open/close the native slide-out cart + keep it in sync.
   Pairs with snippets/cart-drawer.liquid and cart-engine.js.

   IMPORTANT: must load AFTER theme.js (so this file's safe
   window.refreshCart overrides theme.js's broken one that calls
   the nonexistent .sidebar__cart.show()) and BEFORE cart-engine.js
   (so the engine's first syncGift() sees the safe refreshCart).
   ============================================================= */
(function () {
  function drawer()  { return document.querySelector('[data-cart-drawer]'); }
  function overlay() { return document.querySelector('[data-cart-overlay]'); }

  function openDrawer() {
    var d = drawer(), o = overlay();
    if (!d) return;
    if (o) o.hidden = false;
    // Force a reflow so the overlay's display change + the panel's start state
    // are committed before we flip to is-open — the transition then plays.
    // (Synchronous, unlike requestAnimationFrame which is throttled in bg tabs.)
    void d.offsetWidth;
    d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ec-drawer-open');
    var c = d.querySelector('[data-cart-close]');
    if (c) c.focus();
  }

  function closeDrawer() {
    var d = drawer(), o = overlay();
    if (!d) return;
    d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ec-drawer-open');
    if (o) setTimeout(function () { if (!o.classList.contains('is-open')) o.hidden = true; }, 320);
  }

  window.ecOpenCartDrawer = openDrawer;
  window.ecCloseCartDrawer = closeDrawer;

  /* ---------- Triggers ---------- */
  document.addEventListener('click', function (e) {
    // Header "Bag" button (or any explicit toggle) opens the drawer.
    var bag = e.target.closest('.header__cart, [data-cart-drawer-toggle]');
    if (bag) {
      if (!drawer()) return;            // e.g. on /cart there is no drawer — let the link navigate
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-cart-overlay]')) { closeDrawer(); return; }

    // Remove a whole "Custom Set" bundle group at once (all line items share a _bundleId).
    var bRemove = e.target.closest('[data-bundle-remove]');
    if (bRemove) {
      e.preventDefault();
      var block = bRemove.closest('.cart-item--bundle');
      var keys = ((block && block.getAttribute('data-bundle-keys')) || '').split(',').filter(Boolean);
      if (!keys.length) return;
      if (block) block.style.opacity = '0.4';
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { if (window.refreshCart) return window.refreshCart(); })
        .catch(function () { if (window.refreshCart) window.refreshCart(); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });

  /* ---------- Auto-open after add to cart ----------
     <product-form data-ajax-cart> AJAX-adds, swaps content into the
     drawer's #AjaxCartForm, then fires a non-bubbling 'add-to-cart'
     event on itself — caught here in the capture phase. */
  document.addEventListener('add-to-cart', function () {
    if (!drawer()) return;
    if (window.ecCartAfterChange) window.ecCartAfterChange();
    openDrawer();
  }, true);

  /* ---------- Safe cart refresh (replaces theme.js's broken one) ----------
     Apps and cart-engine.js (free gift, upsells) call window.refreshCart().
     Returns a promise so their .then() chains keep working. */
  window.refreshCart = function () {
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc     = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSub  = doc.getElementById('AjaxCartSubtotal');
        var curForm = document.getElementById('AjaxCartForm');
        var curSub  = document.getElementById('AjaxCartSubtotal');

        if (newForm && curForm) {
          curForm.innerHTML = newForm.innerHTML;
          if (curForm.ajaxifyCartItems) curForm.ajaxifyCartItems();
        }
        if (newSub && curSub) curSub.innerHTML = newSub.innerHTML;

        var cnt = curForm && curForm.querySelector('[data-cart-count]');
        if (cnt) document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.textContent = cnt.textContent; });

        if (curForm) curForm.dispatchEvent(new Event('cart-updated'));
        if (window.ecCartAfterChange) window.ecCartAfterChange();
      })
      .catch(function (e) { console.log('refreshCart', e); });
  };

  /* ---------- Legacy event bridge ----------
     The collection-grid quick-add (.ec-hover-btn, injected in layout/theme.liquid)
     AJAX-adds and then fires 'cart:refresh'/'cart:build' — event names from the old
     AOV app. After the migration to this native drawer nothing listened for them, so
     the quick-add opened the drawer with stale markup and the item only appeared
     after a page reload. (The PDP path is unaffected: <product-form data-ajax-cart>
     fires 'add-to-cart', handled above.) Bridge those events to a real refresh.
     Debounced because the quick-add fires both events back to back. */
  var legacyRefreshTimer = null;
  ['cart:refresh', 'cart:build'].forEach(function (evtName) {
    document.addEventListener(evtName, function () {
      clearTimeout(legacyRefreshTimer);
      legacyRefreshTimer = setTimeout(function () {
        if (window.refreshCart) window.refreshCart();
      }, 50);
    });
  });

  /* ---------- Smooth qty update (no jump / no full re-render) ----------
     component-cart.js's updateCartQty replaces the whole cart HTML on every
     +/-, which flashes the list and jumps the progress bar. We override it to
     patch in place: change only the affected line's price + qty, the subtotal,
     and animate the existing progress fill (CSS transition handles the motion).
     Falls back to a full refreshCart on any error. */
  function patchCart(html) {
    var doc     = new DOMParser().parseFromString(html, 'text/html');
    var newForm = doc.getElementById('AjaxCartForm');
    var newSub  = doc.getElementById('AjaxCartSubtotal');
    var curForm = document.getElementById('AjaxCartForm');
    var curSub  = document.getElementById('AjaxCartSubtotal');
    if (!newForm || !curForm) return;

    // If the cart just emptied, a full swap to the empty state is fine.
    if (!newForm.querySelector('.cart-item')) {
      curForm.innerHTML = newForm.innerHTML;
      if (curForm.ajaxifyCartItems) curForm.ajaxifyCartItems();
      if (newSub && curSub) curSub.innerHTML = newSub.innerHTML;
    } else {
      // Progress bar — update text/nodes now, animate the fill width.
      var np = newForm.querySelector('[data-cart-progress]');
      var cp = curForm.querySelector('[data-cart-progress]');
      if (np && cp) {
        var msg = cp.querySelector('.ec-progress__message');
        if (msg) msg.innerHTML = np.querySelector('.ec-progress__message').innerHTML;
        ['data-base-subtotal', 'data-gift-in-cart'].forEach(function (a) { cp.setAttribute(a, np.getAttribute(a)); });
        var nNodes = np.querySelectorAll('.ec-progress__node');
        cp.querySelectorAll('.ec-progress__node').forEach(function (n, i) { if (nNodes[i]) n.className = nNodes[i].className; });
        var newFill = np.querySelector('.ec-progress__fill');
        var curFill = cp.querySelector('.ec-progress__fill');
        // Set directly (not via rAF, which is throttled in background tabs). The
        // fill already has its old width rendered, so this still animates via the
        // CSS `transition: width` on .ec-progress__fill.
        if (newFill && curFill) curFill.style.width = newFill.style.width;
      } else if (cp && !np) { cp.remove(); }

      // Items — patch existing, fade removed, append new (e.g. auto free gift).
      var newItems = {};
      newForm.querySelectorAll('.cart-item').forEach(function (el) { newItems[el.getAttribute('data-id')] = el; });
      curForm.querySelectorAll('.cart-item').forEach(function (cur) {
        var id = cur.getAttribute('data-id');
        var ni = newItems[id];
        if (!ni) {
          cur.style.transition = 'opacity 180ms ease'; cur.style.opacity = '0';
          setTimeout(function () { cur.remove(); }, 180);
        } else {
          var npr = ni.querySelector('.cart-item__price'), cpr = cur.querySelector('.cart-item__price');
          if (npr && cpr) cpr.innerHTML = npr.innerHTML;
          var nq = ni.querySelector('.qty'), cq = cur.querySelector('.qty');
          if (nq && cq && document.activeElement !== cq) cq.value = nq.value;
          delete newItems[id];
        }
      });
      var track = curForm.querySelector('.cart__items');
      Object.keys(newItems).forEach(function (id) { if (track) track.insertAdjacentHTML('beforeend', newItems[id].outerHTML); });

      // Subtotal — full swap so the discount row + totals all update together
      // (the terms gate is gone; only preserve a half-typed promo code).
      if (newSub && curSub) {
        var _promoVal = (curSub.querySelector('[data-promo-input]') || {}).value;
        curSub.innerHTML = newSub.innerHTML;
        if (_promoVal) { var _pi = curSub.querySelector('[data-promo-input]'); if (_pi) _pi.value = _promoVal; }
      }
    }

    var cnt = curForm.querySelector('[data-cart-count]');
    if (cnt) document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.textContent = cnt.textContent; });
    curForm.dispatchEvent(new Event('cart-updated'));
    if (window.ecCartAfterChange) window.ecCartAfterChange();
  }

  function smoothUpdateQty(item, newQty) {
    var key = item.getAttribute('data-id');
    var form = document.getElementById('AjaxCartForm');
    if (form) form.classList.add('processing');
    // optimistic: reflect the new qty immediately
    var qtyInput = item.querySelector('.qty');
    if (qtyInput && newQty > 0) qtyInput.value = newQty;
    var changeUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_change_url) || '/cart/change';
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.status === 422) { return window.refreshCart(); } // stock issue → resync
        return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(patchCart);
      })
      .catch(function () { return window.refreshCart(); })
      .finally(function () { if (form) form.classList.remove('processing'); });
  }

  function installSmoothUpdate() {
    var CF = window.customElements && customElements.get('cart-form');
    if (!CF || CF.__ecSmooth) return;
    CF.__ecSmooth = true;
    CF.prototype.updateCartQty = function (item, newQty) { return smoothUpdateQty(item, newQty); };
  }
  installSmoothUpdate();
  document.addEventListener('DOMContentLoaded', installSmoothUpdate);
})();
